import React from 'react'
import TimeRange from 'react-time-range';

function AddScheduleTime({ newTimeRange, handleTimeRangeChange, AddTimeRangeError, handleSaveTime}) {
  return (
    <div className="modal-content-custom">
        <label className="form-label">Select Time Range</label>
        <TimeRange
            startMoment={newTimeRange.startTime || undefined}
            endMoment={newTimeRange.endTime || undefined}
            onChange={handleTimeRangeChange}
            use24Hours={false}
            minuteIncrement={15}
        />
        {AddTimeRangeError && <div className="error-message">{AddTimeRangeError}</div>}
        <button 
            className="btn-save"
            onClick={handleSaveTime}
            // disabled={!newTimeRange.startTime || !newTimeRange.endTime}
        >
        Save Time
        </button>
    </div>
  )
}

export default AddScheduleTime
